<div class="p-dialog-header">
  <span class="p-dialog-title">{{ title }}</span>
  <div class="p-dialog-header-icons">
    <p-button icon="pi pi-times" styleClass="p-dialog-header-icon p-dialog-header-maximize p-link  p-button-text" (onClick)="closeOrCancel()" />
  </div>
</div>
<div class="body">
  <p class="mt-0">This is a list of save attempts. If you are <span class="fw-bolder">missing data, please report an issue.</span></p>
  <form [formGroup]="formGroup">
    <div class="mb-5">
      @if (logs$ | async; as logs) {
        <p-table [value]="logs" [scrollable]="true" scrollHeight="250px" class="stack">
          <ng-template pTemplate="header">
            <tr>
              <th>Save Date &amp; Time</th>
              <th>User</th>
              <th>Save Status</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-log>
            <tr>
              <td>
                <span class="p-column-title fw-bold">Save Date &amp; Time</span>
                {{ log.requestSent | date: 'MM/dd/yyyy hh:mm a' }}
              </td>
              <td><span class="p-column-title fw-bold">User</span>{{ log.userName }}</td>
              <td [class.p-error]="!log.success">
                <span class="p-column-title fw-bold">Save Status</span
                ><span [ngClass]="{ 'error-text': !log.success }">{{ log.success ? 'Success' : 'Save Failed' }}</span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      }
    </div>
    @if (showSubmitIssueFields) {
      <p class="mb-1 fw-bolder">Issue Description<span class="p-error"> *</span></p>
      <textarea
        pTextarea
        class="w-100 my-1"
        style="height: 120px; resize: none"
        placeholder="Describe the issue"
        [maxLength]="descriptionMaxLength"
        formControlName="description"
      ></textarea>
      <p
        class="text-end fst-italic fw-light"
        [class.p-error]="formGroup.controls.description.invalid && (formGroup.controls.description.dirty || formGroup.controls.description.touched)"
      >
        {{ description.length }} / {{ descriptionMaxLength | number }} character limit
      </p>
      <p class="text-end fst-italic">By submitting this issue, you agree to be contacted by App Support.</p>
    }
    <div class="dialog-button-container">
      <p-button [label]="closeOrCancelLabel" severity="secondary" (onClick)="closeOrCancel()" />
      @if (!showSubmitIssueFields) {
        <p-button label="Report an Issue" styleClass="p-button-danger " icon="pi pi-megaphone" (onClick)="reportAnIssue()" />
      }
      @if (showSubmitIssueFields) {
        <p-button label="Submit Issue" style (onClick)="submitIssue()" />
      }
    </div>
  </form>
</div>
